import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { AlertService } from '../../../services/alert.service';
import { MyTeamsService } from '../../../services/my-teams.service';
import { MyProfileDashboardService } from '../../../services/my-profile-dashboard.service';
import { Store } from '@ngrx/store';
import { AppState, AppTypes, AppFields } from '../../../store';
import * as _ from 'lodash';

@Component({
  selector: 'app-add-an-event-email',
  templateUrl: './add-an-event-email.component.html',
  styleUrls: ['./add-an-event-email.component.css']
})
export class AddAnEventEmailComponent implements OnInit {
  public Editor = ClassicEditor;
  public mailTo: string[];
  public userID;
  @Input() addAnEvent: boolean = false;
  @Input() directorUser;
  @Input() staffList;
  @Input() teamName;
  @Input() isCollegeStaff: boolean;
  @Input() isHighSchoolMail: boolean;
  @Input() highSchoolMailData;
  @Output() close: EventEmitter<boolean> = new EventEmitter();
  @Output() cancel: EventEmitter<boolean> = new EventEmitter();
  @Input() eventUserEmailList;
  form: FormGroup;

  staffEmailList: any[];
  eventID: number = 0;
  userData: any;
  SenderEmail: any;
  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private service: MyTeamsService,
    private alertService: AlertService,
    private dashboardService: MyProfileDashboardService,
    private store: Store<AppState>
  ) {
    this.eventID = this.route.snapshot.params.eventID;
    this.store.select(AppFields.App, AppFields.User).subscribe((rs: any) => {
      if (rs) {
        this.userData = rs;
        this.SenderEmail = rs.email;
      }
    });
  }

  ngOnInit() {
    this.userID = localStorage.getItem('userId');
    this.initForm();
    this.setFormValues();
  }

  initForm() {
    this.form = this.fb.group({
      MailTo: [null, Validators.required],
      Subject: [null, Validators.required],
      Message: [null, Validators.required]
    });
  }

  setFormValues() {
    this.mailTo = [];
    if (this.eventUserEmailList) {
      _.map(this.eventUserEmailList, (item: any) => {
        this.mailTo.push(item.Email);
      });
      this.form.controls['Subject'].setValue('Request a reciprocal deal for this event.');
      //this.form.controls['Subject'].disable();
      this.form.controls['MailTo'].disable();
    } else if (this.addAnEvent && !this.directorUser) {
      this.mailTo.push('help@totalglobalsports.com');
      this.form.controls['Subject'].setValue('Add An Event');
      this.form.controls['Subject'].disable();
      this.form.controls['MailTo'].disable();
    } else if (this.directorUser != null && this.directorUser.userID > 0) {
      this.mailTo.push(this.directorUser.email);
      this.form.controls['MailTo'].disable();
    } else if (this.staffList != null && this.staffList.length > 0) {
      for (let i = 0; i < this.staffList.length; i++) {
        this.mailTo.push(this.staffList[i].fullName);
      }
      if (!this.isCollegeStaff) {
        this.form.controls['Subject'].setValue(this.teamName + " request a change to their Application");
        this.form.controls['Subject'].disable();
      }
      this.form.controls['MailTo'].disable();
    } else if (this.isHighSchoolMail) {
      if (this.highSchoolMailData !== null) {
        this.mailTo.push(this.highSchoolMailData.to);
        this.form.controls['Subject'].setValue(this.highSchoolMailData.subject);
        this.form.controls['Subject'].disable();
        this.form.controls['MailTo'].disable();
      }
    }

    this.form.patchValue({
      MailTo: this.mailTo.join(', ')
    });
  }

  onSubmit(event) {
    event.target.innerHTML = 'Sending <i class="fa fa-spinner fa-spin push-5-r"></i>';
    event.target.disabled = true;

    if (this.eventUserEmailList) {
      const obj = {
        EventID: this.eventID,
        SenderEmail: this.SenderEmail,
        EventAdminEmailList: this.eventUserEmailList,
        Subject: this.form.value.Subject,
        MessageBody: this.form.value.Message
      };
      console.log(obj);
      this.service.sendEmailToRequestReciprocalDeal(obj).subscribe((data: any) => {
        this.emailSentSuccessfully(event);
      }, error => {
        console.log(error);
        this.errorWhileSendingEmail(event);
      });
    }
    else if (this.addAnEvent && !this.directorUser) { // Send Email To Add An Event
      const obj = {
        PlayerID: this.userID,
        MessageBody: this.form.value.Message
      };
      this.service.sendEmailToAddAnEvent(obj).subscribe((data: any) => {
        this.emailSentSuccessfully(event);
      }, error => {
        console.log(error);
        this.errorWhileSendingEmail(event);
      });
    }
    else if (this.directorUser != null && this.directorUser.userID > 0) {  //Send Email To Director
      const obj = {
        SenderID: this.userID,
        EventDirectorList: [{
          UserID: this.directorUser.userID,
          Email: this.directorUser.email
        }],
        Subject: this.form.value.Subject,
        MessageBody: this.form.value.Message
      };
      this.service.sendEmailToDirector(obj).subscribe((data: any) => {
        this.emailSentSuccessfully(event);
      }, error => {
        console.log(error);
        this.errorWhileSendingEmail(event);
      });
    }
    else if (this.staffList != null && this.staffList.length > 0) {

      this.staffEmailList = [];

      for (let i = 0; i < this.staffList.length; i++) {
        var list: any;
        list = {
          UserID: this.staffList[i].userID,
          Email: this.staffList[i].email
        };
        this.staffEmailList.push(list);
      }

      var obj;

      if (this.isCollegeStaff) {
        obj = {
          SenderID: this.userID,
          EventDirectorList: this.staffEmailList,
          Subject: this.form.value.Subject,
          MessageBody: this.form.value.Message
        };

        this.service.sendEmailToDirector(obj).subscribe((data: any) => {
          this.emailSentSuccessfully(event);
        }, error => {
          console.log(error);
          this.errorWhileSendingEmail(event);
        });
      }
      else {
        obj = {
          UserID: this.userID,
          FirstName: "",
          LastName: "",
          MessageBody: this.form.value.Message,
          Subject: this.teamName + " request a change to their Application",
          collegeCoachList: this.staffEmailList
        };

        this.service.sendApplicationRequestMessage(obj).subscribe((data: any) => {
          this.emailSentSuccessfully(event);
        }, error => {
          console.log(error);
          this.errorWhileSendingEmail(event);
        });
      }
    }
    else if (this.highSchoolMailData != null && this.isHighSchoolMail == true) {
      const obj = {
        PlayerID: this.highSchoolMailData.playerID,
        MessageBody: this.form.value.Message
      };
      this.dashboardService.addSchoolEmail(obj).subscribe((data: any) => {
        this.emailSentSuccessfully(event);
      }, error => {
        console.log(error);
        this.errorWhileSendingEmail(event);
      });
    }
  }

  emailSentSuccessfully(event) {
    event.target.disabled = false;
    event.target.innerHTML = 'Send';
    this.alertService.success("Sent Email Successfully.");
    this.close.emit(false);
    this.resetForm();
  }

  errorWhileSendingEmail(event) {
    event.target.disabled = false;
    event.target.innerHTML = 'Send';
    this.alertService.error("Email not sent.");
    this.form.enable();
  }

  onClose(event: Event) {
    //event.preventDefault();
    this.close.emit(false);
    this.resetForm();
  }

  onCancel() {
    this.cancel.emit(false);
    this.resetForm();
  }

  resetForm() {
    this.form.enable();
    this.form.patchValue({
      mailTo: null,
      subject: null,
      message: null
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/add-an-event-email/add-an-event-email.component.ts